//logos

export const logoBooking =
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678401479/bookingcom-1_br2vnl.svg";
export const logoGoogle =
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1681939745/ic-google_oky7ev.svg";
export const estrellas =
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678539690/five-stars_tulo1k.png";
export const arboles =
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678733402/151-1514311_arboles-png-imagenes-de-arboles-png_h3swnv.jpg";
export const Logo =
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1681249084/A_color_letras_blancas_dlzn22.png";
export const LogoMobile =
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1681248175/A_color_horizontal_letras_blancas_phbgwe.png";

export const icono =
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683912682/288647981_159432233250467_7958409299853297874_n_lcvjxa.jpg";
//carousel

export const surImg = [
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889375/surExterior_galic6.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678662425/cabania_sur_m8pjh0.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889377/surCocina_ewee6a.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889377/surCama_tidrjg.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889377/surCama2_jtusy8.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889377/surAbitacionNinios_li6hzv.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889376/surCocina2_rug1hp.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889376/surBanio_dgmbhu.jpg",
];

export const norteImg = [
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889376/norteCama_csyu1l.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889376/norteSILLON_bcvhcf.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889376/norteCocina_fuck6z.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889376/norteCama2_yjnaul.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889375/norteHabitacionNinios_mtd4br.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889375/norteLiving2_iztvfg.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889375/norteLiving_flomwy.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889375/noteCocina2_kat4ih.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1678889375/norteBanio_jljwbq.jpg",
];

export const piscinaImg = [
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1679951895/piscina_ai0zjp.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1679951895/piscina4_ae6w1a.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1679951887/piscina5_xonzyo.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1679951895/piscina3_btpcsp.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1679951895/piscina2_kujjlk.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1679951895/piscina4_ae6w1a.jpg",
];

export const adventure = [
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683043695/merlo-activity1-1_toq4zo.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683043695/merlo-activity2_gftuu2.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683043695/merlo-activity3_zdpeo9.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683043695/merlo-activity-4_v4kg2m.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683043694/merlo-activity-5_kvusj7.jpg",
];

export const merloImg = [
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683144022/6146025d83016580367141_mech6i.jpg",
	"https://i0.wp.com/leerdelviaje.com/wp-content/uploads/2019/10/20191006_151343.jpg?resize=1585.25%2C797&ssl=1",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683144022/6146052a6fdc2905600759_xtmiaf.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1683144022/61460488e3d39763564916_ho3kuf.jpg",
	"https://blog.iunigo.com.ar/wp-content/uploads/2022/12/Merlo_SanLuis-1-iunigo.jpeg",
	"https://www.miviaje.info/wp-content/uploads/2015/08/CASCADA-MERLO.jpg",
];

export const homeImg = [
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1684086825/imagen_caba%C3%B1a_1_nzgfw6.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1684086825/imagen_caba%C3%B1as_2_asd8qh.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1684086825/imagen_caba%C3%B1as_3_rwt3mm.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1684086825/imagen_caba%C3%B1a_4_fuxtjx.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1684086825/imagen_caba%C3%B1a_5_u8p4ck.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1684086826/imagen_caba%C3%B1a_6_zblzud.jpg",
	"https://res.cloudinary.com/drhj3sc2o/image/upload/v1684086825/imagen_caba%C3%B1a_7_n2vmk2.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1683568807/piletaCarouselNueva_fwy7dr.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1676404401/yanasuyVistasierra_kokuei.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1676403664/piletayplantasCarousel_lf0g4t.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1676404390/yanasuyVistaCabania_llle5i.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1676404371/yanasuyVistaCabania2_kgmrfz.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1683568738/IMG-20230506-WA0019_t3hcsa.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1683568891/parqueNoche_mhiwrf.jpg",
	// "https://res.cloudinary.com/drhj3sc2o/image/upload/v1683568903/sociedad_z4spdo.jpg",
];
